const injectEditorFont = (liveDOM) => {
  const editorFontStyles = `
    <link href="https://fonts.googleapis.com/css?family=Roboto:400,500&display=swap" rel="stylesheet">
    <style>:root { --ws-editor-font-family: 'Roboto', sans-serif; }</style>
  `;

  liveDOM.head.insertAdjacentHTML('beforeend', editorFontStyles);
};

export default injectEditorFont;
